import * as React from 'react';
import styled from "styled-components";
import {inject, observer} from "mobx-react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IBaseView} from "../../_base/base-view";
import {cl_gray100, cl_green} from "../../_theme/colors";


const Header = styled.h6`
text-align: center;
`;

const Liste = styled.ul`
     padding-inline-start:0;
     background-color: ${cl_gray100};

`;

const ListItem = styled.li`
   display:block;
   cursor:pointer;
   text-overflow: ellipsis;
   white-space: nowrap;
   overflow:hidden;
`;


@inject('rootStore')
@observer
export class AuditCollectElementList extends React.Component<IBaseView, {}> {

    onClick = (label: string) => {
        const {rootStore: {inspectionStore: {setElement}}} = this.props;
        return () => setElement(label);
    };

    render() {
        const {rootStore: {inspectionStore: {elements, actElement}, langStore: {lang}}} = this.props;
        return (
            <>
                <Header>{lang.AUDIT_ELEMENTS}</Header>
                <Liste>
                    {elements.map(
                        (element, i) => {
                            return (
                                <ListItem key={i} onClick={this.onClick(element.label)}>
                                    <FontAwesomeIcon color={element.completed ? cl_green : cl_gray100} icon="check"/>
                                    &nbsp;&nbsp;
                                    {element.label === actElement ? <b>{element.label}</b> : element.label}
                                </ListItem>
                            )
                        }
                    )}
                </Liste>
            </>
        )
    }
}